import { LZ_APP_BASE_URI } from "../_config/Config";

const lzAppBaseUri = window.LZ_APP_BASE_URI && window.LZ_APP_BASE_URI !== '' ? window.LZ_APP_BASE_URI : LZ_APP_BASE_URI;

/**
 * This object holds the App related global constants.
 *
 * @type object
 */
export const LzAppConstants = {
    app_code: 'Lz2ADSrvD',
    app_name: '2AData.com Services for Dealers',
    app_base_url: lzAppBaseUri + 'dealers/',
    app_api_endpoint_url: lzAppBaseUri + 'dealers/api/',
};
